export const PHONE_NUMBER = '7065360360';